import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarEntradasSemEstoqueConsolidadoDashboard(axios) {
    let parametros = {
      operacao: 'buscarEntradasSemEstoqueConsolidadoDashboard'
    };

    let retorno = {};

    await axios.santriGET('/rest/entrada', parametros, 15, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })

    return retorno;
  }
}


// WEBPACK FOOTER //
// ./src/components/Rest/REntrada/REntradaBuscarEntradasSemEstoqueConsolidadoDashboard.js